import React, { useState, useReducer } from "react";
import { Alert, AlertTitle } from "@material-ui/lab/";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Paper, Link, Container } from "@material-ui/core/";
import NtkButton from "../services/common/NtkButton";
import NtkInputField from "../contact/NtkInputField";

const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.down("sm")]: {
      padding: "3rem 2.3rem",
    },
    textAlign: "center",
    marginTop: "4rem",
    padding: "4.8rem 2.3rem",
    color: theme.palette.text.secondary,
  },
  link: {
    marginTop: "4rem",
  },
  alert: {
    margin: "20px auto",
    textAlign: "left",
    width: "fit-content",
  },
}));

export default function Form() {
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();

  const [requestForm, setRequestForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      title: "",
      email: "",
      organization: "",
      translation: "",
      words: "",
      transcription: "",
    }
  );

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setRequestForm({ [name]: newValue });
  };

  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSent(true);
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Container maxWidth="lg">
        <Paper elevation={6} className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <NtkInputField
                name="name"
                value={setRequestForm.title}
                onChange={handleChange}
                fullWidth
                required
                type={"text"}
                placeholder="Name"
              ></NtkInputField>
            </Grid>

            <Grid item xs={12} md={6}>
              <NtkInputField
                name="email"
                value={setRequestForm.email}
                onChange={handleChange}
                fullWidth
                required
                type={"email"}
                placeholder="Email"
              ></NtkInputField>
            </Grid>

            <Grid item xs={12} md={6}>
              <NtkInputField
                name="organization"
                value={setRequestForm.organization}
                onChange={handleChange}
                fullWidth
                required
                type="text"
                placeholder="Organization"
              ></NtkInputField>
            </Grid>

            <Grid item xs={12} md={6}>
              <NtkInputField
                name="translation"
                value={setRequestForm.translation}
                onChange={handleChange}
                fullWidth
                required
                type="text"
                placeholder="Type of Translation"
              ></NtkInputField>
            </Grid>

            <Grid item xs={12} md={6}>
              <NtkInputField
                name="words"
                value={requestForm.words}
                onChange={handleChange}
                fullWidth
                required
                type="text"
                placeholder="How many words are in your documents?"
              ></NtkInputField>
            </Grid>

            <Grid item xs={12} md={6}>
              <NtkInputField
                name="transcription"
                value={requestForm.transcription}
                onChange={handleChange}
                fullWidth
                required
                type="text"
                placeholder="If transcription, how many minutes are in your file?"
              ></NtkInputField>
            </Grid>
          </Grid>

          <Typography
            className={classes.link}
            variant="subtitle1"
            color="secondary"
          >
            <Link
              color="textSecondary"
              href="https://airtable.com/shrE4GKw8KSsXRkcZ"
              onClick={preventDefault}
            >
              https://airtable.com/shrE4GKw8KSsXRkcZ
            </Link>
          </Typography>
          {isSent ? (
            <Container>
              <Alert className={classes.alert} severity="success">
                <AlertTitle>Send</AlertTitle>
                Thank you for contacting us. We' ll respond you as soon as
                possible.
              </Alert>
            </Container>
          ) : (
            <NtkButton title="Submit" type="submit" />
          )}
        </Paper>
      </Container>
    </form>
  );
}
